module.exports = __webpack_public_path__ + "img/rank_bg.03208730.png";